module.exports = __webpack_public_path__ + "fromBrideToFather-we-g.adf416ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-we-g.jpg
// module id = SJGZ
// module chunks = 0